export interface LocaleMessages {
	[key: string]: any
}

export interface LocaleOptions {
	[key: string]: any
}

/**
 * 响应式语言标记，用于触发组件更新
 */
export declare const langKey: number

/**
 * 翻译函数
 * @param path 翻译路径，支持点分隔的嵌套路径
 * @param options 格式化参数
 * @returns 翻译后的文本
 */
export declare function t(path: string, ...options: any[]): string

/**
 * 设置当前语言包
 * @param lang 语言包对象
 */
export declare function use(lang: LocaleMessages): void

/**
 * 设置国际化处理函数
 * @param fn 自定义的国际化处理函数
 */
export declare function i18n(fn: (...args: any[]) => any): void

declare const _default: {
	use: typeof use
	t: typeof t
	i18n: typeof i18n
	langKey: typeof langKey
}

export default _default
